export default __webpack_public_path__ + "static/media/play.54d53fb0.svg";